module.exports = __webpack_public_path__ + "img/number-thumb-16.a5cc3471.jpg";